import {DropzoneComponent} from 'react-dropzone-component';
import 'react-dropzone-component/styles/filepicker.css';
import 'dropzone/dist/min/dropzone.min.css';
import React, {Component} from 'react';
import {Button, Header, Icon} from 'semantic-ui-react';
import {uploadPVTitleImage} from "../../data/property_visit_api";
import * as unavailable from "../../assets/photo_unavailable.jpg";
import Loader from "../universal/loader";

const uuidv1 = require('uuid/v1');

class PropertyVisitReportTitlePage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            attachments: [],
            maxNumberOfFilesExceeded: false,
            saved: false,
            uploading:false,
            preLoaded:false
        };
    }

    handleSubmit = (reportId) => {
        this.setState({uploading:true});
        const formData = new FormData();
        formData.append("report_id", reportId);
        if (this.state.attachments.length > 0 && !this.state.preLoaded) {
            formData.append("images[file]", this.state.attachments[0]);
            uploadPVTitleImage(formData).then(() => {
                this.setState({saved: true,uploading:false,attachments:[]});
                setTimeout(() => {
                    this.setState({saved: false})
                }, 20000);
            });
        }
        else {
            this.setState({saved: false,uploading:false});
            setTimeout(() => {
                this.setState({saved: false})
            }, 20000);
        }
    };

    preloadImages = (dropzone) => {
        const titleImage = this.props.titleImage;
        if (titleImage && titleImage["report"]["url"]) {
            const name = titleImage.id;
            const file = { url: titleImage['report']['url']? titleImage['report']['url']:unavailable, name: name, size: 1000000, id: name};
            const imageUrl =  titleImage['report']['url'];

            file['serverId'] = name;
            file['accepted'] = true;
            file['status'] = 'success';
            file['upload'] = {
                progress: 100,
                total: 100000,
                bytesSent: 100000
            };
            dropzone.files.push(file);
            this.state.attachments.push(file);
            this.setState({preLoaded:true});
            dropzone.emit("addedfile", file);
            dropzone.emit("thumbnail", file, imageUrl);
            dropzone.emit("complete", file);
        }
    };

    render() {
        let dropZone = null;
        const componentConfig = {postUrl: 'no-url'};
        let djsConfig = {autoProcessQueue: false, addRemoveLinks: true, maxFiles: 1,acceptedFiles:"image/*"};
        const eventHandlers = {
            init: (dropzone) => {
                dropZone = dropzone;
                dropZone.autoDiscover = false;
                this.preloadImages(dropzone);
            },
            addedfile: (file) => {
                this.state.attachments.push(file);
                this.setState({fileAdded:true,preLoaded:false});
            },
            removedfile: (file) => {
                this.setState({attachments:[]});            },
            maxfilesexceeded: (file) => {
                dropZone.removeFile(file);
                this.setState({maxNumberOfFilesExceeded: true});
                setTimeout(() => {
                    this.setState({maxNumberOfFilesExceeded: false})
                }, 10000)
            }
        };

        return (<div>
            {this.state.uploading && <Loader save={true}/>}
            <Header textAlign="left"> Title Page {this.state.saved && <span className="info-success">Saved!</span>}
                <Button primary compact content="Save" disabled={this.state.uploading} loading={this.state.uploading}
                        className="pull-right icon-button" onClick={(e) => {
                    this.handleSubmit(this.props.reportId)
                }}/>{this.state.attachments.length > 0 && !this.state.preLoaded && <span className="pull-right"><Icon name="warning sign" color="orange" size="large"/></span>} </Header>
            {this.state.maxNumberOfFilesExceeded &&
            <p><span className="error-message">Max number of allowed files is 1</span></p>}
            <DropzoneComponent key={this.props.reportId} config={componentConfig}
                               eventHandlers={eventHandlers}
                               djsConfig={djsConfig}/>
        </div>);
    }
}

export default PropertyVisitReportTitlePage;


// WEBPACK FOOTER //
// ./src/views/property_visits/property_visit_report_title_page.js